<template>
    <section class="encabezado">
        <div class="medio">
            <div class="container ">
                <div class="row align-items-center ">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <h1 class="text-center"><slot name="slotTitle"></slot></h1>
                        <p class="text-center"><slot name="slotRoute"></slot></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
	name: "Cbarra",
	props: [],
	components: {
	},
	data() {
		return {
        };
	},
	methods: {
    },
	created() {},
	computed: {
    },
};
</script>